export default __webpack_public_path__ + "static/media/remove.260546d7.svg";